import { useEffect, useRef, useState } from 'react'
import styles from './NumericRange.module.scss'
import { ScoopButton, ScoopMenu, ScoopSlider, ScoopTextField } from '../../../../ui'

export const NumericRange = ({
    value,
    onChange,
    min,
    max,
    containerSx,
    label,
    popWidth,
    isGuestMode,
    theme,
}) => {
    const anchor = useRef()
    const [showSlider, setShowSlider] = useState(false)
    const [innerValue, setInnerValue] = useState([0, 0])

    const getMinValue = () => {
        if (min !== null) return min || 0
        else return 0
    }

    useEffect(() => {
        if (value) setInnerValue(value)
        else setInnerValue([getMinValue(), max || 1000000])
    }, [min, max, value])

    const handleInputChange = (value, from) => {
        if (from === 'min') {
            if (value >= min) setInnerValue([value, innerValue[1]])
        }
        if (from === 'max') {
            if (value <= max) setInnerValue([innerValue[0], value])
        }
    }

    const handleApply = () => {
        onChange(innerValue)
        setShowSlider(false)
    }

    const isDarkTheme = theme?.colorScheme?.darkTheme
    const backgroundColor = theme?.colorScheme?.backgroundColor || ''

    return (
        <>
            <div className={styles.container} style={containerSx}>
                {label && <span className={styles.label}>{label}</span>}
                <div
                    className={styles.input}
                    ref={anchor}
                    onClick={() => !isGuestMode && setShowSlider(true)}
                    style={{
                        backgroundColor,
                        color: isDarkTheme ? 'white' : '',
                        border: isDarkTheme ? '1px solid white' : '',
                    }}
                >
                    <span className={styles.inputText}>
                        {value ? value[0] + ' to ' + value[1] : 'Select range'}
                    </span>
                </div>
            </div>
            <ScoopMenu
                open={showSlider}
                anchorEl={anchor.current}
                onClose={() => setShowSlider(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                className={styles.popup}
                style={{
                    width: popWidth,
                    backgroundColor,
                    backdropFilter: backgroundColor === '#00000000' ? 'blur(20px)' : '',
                }}
            >
                <div className={styles.inputsRow}>
                    <div className={styles.inputGroup}>
                        <label
                            className={styles.inputLabel}
                            style={{ color: isDarkTheme ? 'white' : '' }}
                        >
                            Min
                        </label>
                        <div className={styles.inputWrapper}>
                            <ScoopTextField
                                className={styles.valueInput}
                                value={innerValue[0]}
                                type="number"
                                onChange={(e) => handleInputChange(e.target.value, 'min')}
                                inputProps={{
                                    sx: { color: isDarkTheme ? 'white' : '' },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        border: isDarkTheme ? '1px solid white' : '',
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.inputGroup}>
                        <label
                            className={styles.inputLabel}
                            style={{ color: isDarkTheme ? 'white' : '' }}
                        >
                            Max
                        </label>
                        <div className={styles.inputWrapper}>
                            <ScoopTextField
                                className={styles.valueInput}
                                value={innerValue[1]}
                                type="number"
                                onChange={(e) => handleInputChange(e.target.value, 'max')}
                                inputProps={{
                                    sx: { color: isDarkTheme ? 'white' : '' },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        border: isDarkTheme ? '1px solid white' : '',
                                    },
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.sliderWrapper}>
                    <ScoopSlider
                        value={innerValue}
                        onChange={(value) => setInnerValue(value)}
                        min={getMinValue()}
                        max={max || 1000000}
                    />
                </div>
                <div className={styles.footer}>
                    <ScoopButton
                        onClick={() => setShowSlider(false)}
                        className={styles.button}
                        variant="outlined"
                        style={{ color: isDarkTheme ? 'white' : '' }}
                    >
                        Cancel
                    </ScoopButton>
                    <ScoopButton onClick={handleApply} className={styles.button}>
                        Apply
                    </ScoopButton>
                </div>
            </ScoopMenu>
        </>
    )
}
